<!-- 添加/修改推送时间模板，bluesky:2023-10-05 -->
<template>
  <div class="add-or-edit-section">
    <el-form :label-position="'right'" label-width="120px" :model="formData" :rules="rules" ref="form">

        <el-form-item label="类型:" prop="regulateType">
          <el-select @change="changeType" v-model="formData.regulateType" placeholder="请选择">
              <el-option
                v-for="item in typeList"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
        </el-form-item>

       <el-form-item label="发证月份:" prop="certMonth">
         <el-select v-model="formData.certMonth" placeholder="请选择">
             <el-option
               v-for="item in 12"
               :key="item"
               :label="item+'月'"
               :value="item">
             </el-option>
           </el-select>
       </el-form-item>



        <el-form-item label="第1次提醒时间:" prop="time1">
          <el-date-picker v-model="formData.time1" type="datetime" placeholder="选择日期"
          	format="yyyy-MM-dd 10:00:00"
            value-format="yyyy-MM-dd 10:00:00">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="第2次提醒时间:" prop="time2">
          <el-date-picker v-model="formData.time2" type="datetime" placeholder="选择日期"
          	format="yyyy-MM-dd 10:00:00"
            value-format="yyyy-MM-dd 10:00:00">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="第3次提醒时间:" prop="time3">
          <el-date-picker v-model="formData.time3" type="datetime" placeholder="选择日期"
          	format="yyyy-MM-dd 10:00:00"
            value-format="yyyy-MM-dd 10:00:00">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="第4次提醒时间:" prop="time4">
          <el-date-picker v-model="formData.time4" type="datetime" placeholder="选择日期"
          	format="yyyy-MM-dd 10:00:00"
            value-format="yyyy-MM-dd 10:00:00">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="第5次提醒时间:" prop="time5">
          <el-date-picker v-model="formData.time5" type="datetime" placeholder="选择日期"
          	format="yyyy-MM-dd 10:00:00"
            value-format="yyyy-MM-dd 10:00:00">
          </el-date-picker>
        </el-form-item>

        <div>
          <div slot="footer" class="dialog-footer-in-form">
            <el-button plain @click="close">取消</el-button>
              <el-button type="primary" @click="submit">提交</el-button>
          </div>
        </div>

    </el-form>
  </div>
</template>

<script>
export default {
    props:{
        idInput:null,
    },
    created(){
    	this.formData.id = this.idInput;
    	//如果idInput不为空，表示修改
    	if(this.idInput && this.idInput != null){
    		this.getItem();
    	}

      // 获取所有监管类型列表
      this.getRegulateTypeList();
    },
    data(){
        return {
            formData: {
              id:null,// 推送时间模板ID
              regulateType:null,// 监管类型（0=年度，1=分期，2=巡查，3=关闭，4=其他）
              certMonth:null,// 发证月份（1、2、3...）
              time1:null,// 第1次提醒时间
              time2:null,// 第2次提醒时间
              time3:null,// 第3次提醒时间
              time4:null,// 第4次提醒时间
              time5:null,// 第5次提醒时间
            },
            rules:{
                certMonth:{required:true,message:'发证月份不能为空',trigger:'blur'},
                regulateType:{required:true,message:'监管类型不能为空',trigger:'blur'},
                time1:{required:true,message:'第1次提醒时间不能为空',trigger:'blur'},
                time2:{required:true,message:'第2次提醒时间不能为空',trigger:'blur'},
                time3:{required:true,message:'第3次提醒时间不能为空',trigger:'blur'},
                time4:{required:true,message:'第4次提醒时间不能为空',trigger:'blur'},
                time5:{required:true,message:'第5次提醒时间不能为空',trigger:'blur'},
            },

            hasTreeDescBool:false,
            hasWeatherDescBool:false,


            // 监管类型列表
            typeList:[],

            // 监管阶段列表
            stageList:[],
        }
    },
    methods:{
      // 改变类型
      changeType(){

      },
      // 获取所有监管类型列表
      getRegulateTypeList(){
        this.$apis.get('/admin/project/getRegulateTypeList', {
        }).then(res => {
          if(res.data.code == 200){
            this.typeList = res.data.data;
            this.typeList = this.typeList.filter(x => x.name == '年度');
          }
          else{
            this.$message({
              type: 'error',
              message: `${res.data.data}`
            });
          }
        });
      },
      getItem(){
        this.$apis.get('/admin/timeTpl/get', {
          id:this.formData.id
        }).then(res => {
          if(res.data.code == 200){
            this.formData = res.data.data;
            this.hasTreeDescBool = res.data.data.hasTreeDesc == 1;
            this.hasWeatherDescBool = res.data.data.hasWeatherDesc == 1;
          }
          else{
            this.$message({
              type: 'error',
              message: `${res.data.data}`
            });
          }
        });
      },

      submit(){
        //验证rules
        this.$refs.form.validate(async (valid)=>{
          console.log(valid)
          if(valid){
            let url = this.formData.id && this.formData.id != "" ? "/admin/timeTpl/update" : "/admin/timeTpl/add";
            this.$apis.post(url, this.formData).then(res => {
              if(res.data.code == 200){
                this.formData = res.data.data;
                this.$emit("success");
                this.$message({
                  type: 'success',
                  message: `操作成功！`
                });
              }
              else{
                this.$message({
                  type: 'error',
                  message: `${res.data.data}`,
                  duration:5000
                });
              }
            });
          }
        });
      },
      // 关闭
      close(){
        this.$emit("close");
      },

    }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/page/components/addOrEditTimeTpl.vue